import { createRouter, createWebHashHistory, createWebHistory, } from "vue-router";
import { setupPermissions } from "./permissions";
import { authentication, isHashRouterMode, publicPath } from "@/config";
import { useRoutesStore } from "@/store/modules/routes";
import { title } from "@/config";
export const constantRoutes = [
    {
        path: "/visualization",
        name: "visualization",
        component: () => import("@/views/index/index.vue"),
        redirect: "/visualization/childustody", // 使用相对路径
        meta: { hidden: false },
        children: [
            {
                path: "/visualization/childustody", // 相对路径（无斜杠开头）
                name: "childustody",
                component: () => import("@/views/index/page/childustody.vue"),
                meta: { title: title },
            },
            {
                path: "/visualization/industrySupervision",
                name: "industrySupervision",
                component: () => import("~/src/views/index/page/industrySupervision.vue"),
                meta: { title: title },
            },
            {
                path: "/visualization/revenueTax",
                name: "revenueTax",
                component: () => import("~/src/views/index/page/revenueTax.vue"),
                meta: { title: title },
            },
            {
                path: "/visualization/governmentServicesUpdates",
                name: "governmentServicesUpdates",
                component: () => import("~/src/views/index/page/governmentServicesUpdates.vue"),
                meta: { title: title },
            },
        ],
    },
    {
        path: "/hotelInformationDetails",
        name: "hotelInformationDetails",
        meta: {
            title: "旅店信息详情",
        },
        component: () => import("@/views/index/page/hotelInformationDetails/index.vue"),
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("@/views/login/index.vue"),
        meta: {
            hidden: true,
        },
    },
    {
        path: "/403",
        name: "403",
        component: () => import("@/views/403.vue"),
        meta: {
            hidden: true,
        },
    },
    {
        path: "/404",
        name: "404",
        component: () => import("@/views/404.vue"),
        meta: {
            hidden: true,
        },
    },
    {
        path: "/index",
        name: "Index",
        component: () => import("@/views/index/index.vue"),
        meta: {
            hidden: true,
        },
    },
];
export const asyncRoutes = [
// {
//   path: "/",
//   name: "Root",
//   component: Layout,
//   meta: {
//     hidden: false,
//     icon: "menu_industry",
//     title: "行业数据",
//   },
//   children: [
//     {
//       path: "/stayhome",
//       name: "stayhome",
//       component: () => import("@/views/Industry/Stay/index.vue"),
//       meta: {
//         title: "数据总览",
//       },
//     },
//   ],
// },
];
const router = createRouter({
    history: isHashRouterMode
        ? createWebHashHistory(publicPath)
        : createWebHistory(publicPath),
    routes: constantRoutes,
});
function fatteningRoutes(routes) {
    return routes.flatMap((route) => {
        return route.children ? fatteningRoutes(route.children) : route;
    });
}
function addRouter(routes) {
    routes.forEach((route) => {
        if (!router.hasRoute(route.name))
            router.addRoute(route);
        if (route.children)
            addRouter(route.children);
    });
}
export function resetRouter(routes = constantRoutes) {
    routes.map((route) => {
        if (route.children)
            route.children = fatteningRoutes(route.children);
    });
    router.getRoutes().forEach(({ name }) => {
        router.hasRoute(name) &&
            router.removeRoute(name);
    });
    addRouter(routes);
}
export function setupRouter(app) {
    if (authentication === "intelligence")
        addRouter(asyncRoutes);
    setupPermissions(router);
    app.use(router);
    return router;
}
// 添加全局前置守卫
router.beforeEach((to) => {
    const routesStore = useRoutesStore();
    // 当路径是 /index 时隐藏 header
    if (to.path === "/visualization/childustody") {
        routesStore.setHeaderVisible(false);
    }
    else {
        routesStore.setHeaderVisible(true); // 其他路径显示 header
    }
});
export default router;
